import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';

/**
 * Categoría del mueble: qué ES cada mueble físico.
 *
 * No confundir con "Rango venta de mueble", que son los tramos de
 * venta del cliente. Varios muebles comparten una categoría.
 */
export default WithApp(function ModalFurnitureCategory(props) {
  const category = props.model;

  return (
    <Modal
      title="Categoría de mueble"
      model={category}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/furniture-category"
    >
      <TextField
        label="Código"
        type="text"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={category?.code || ''}
        inputProps={{ maxLength: 20 }}
        helperText="No se puede repetir"
        required
      />

      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={category?.description || ''}
        helperText="Por ejemplo Chico, Grande o Abierto para autoservicio"
        required
      />
    </Modal>
  );
});
